<template>
  <div class='section' :class='{ serif, centered }'>
    <slot></slot>
  </div>
</template>
<script>
export default {

  props: {
    serif: {
      type: Boolean
    },
    centered: {
      type: Boolean
    }
  }
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';

div.centered {
    text-align: center;
}

div.serif {
  font-family: @serif-font !important;
  font-size: @default-font-size * 0.6 !important;
  padding: 17pt !important;
}

div.section {
  position: relative;
  margin: 0;
  left: 0;
  right: 0;
  padding: .5em 1.5em;
  font-family: @cursive-font;
  font-size: @default-font-size * 1.2;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

div.section > div {
  flex: 0 0 50%;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/TextSection.vue